import { render, staticRenderFns } from "./contactusform.vue?vue&type=template&id=565af882&"
import script from "./contactusform.vue?vue&type=script&lang=js&"
export * from "./contactusform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports